// extracted by mini-css-extract-plugin
export var textInput = "_k4-0";